/* eslint-disable react/prop-types */

import Image from "next/image";
import Link from "next/link";
import { sanitize, adjustColor } from '@/utils/misc';
import studioStore from '@/stores/studioStore';

function AboutSection({
  sectionTitle,
  backgroundImage,
  backgroundColor = "#ffffff",
  sectionRightImage,
  sectionLeftImage,
  sectionContent,
  buttonText,
  buttonLink,
}) {
  const primaryColor = studioStore.settings.colors.primary_color;
  const hoverPrimaryColor = adjustColor(primaryColor, -30);

  const aboutTitleWords = sectionTitle?.split(" ") || [];
  const lastWord = aboutTitleWords.pop();
  const remainingTitle = aboutTitleWords.join(" ");

  return (
    <div className="relative section-about py-10" style={{ backgroundColor }}>
      {backgroundImage?.url && (
        <Image
          src={backgroundImage.url}
          alt="About Background"
          fill
          style={{ objectFit: "cover" }}
          quality={80}
          className="z-0"
        />
      )}
      <div className="relative z-10">
        <div className="container mx-auto">
          <div className="flex flex-col md:flex-row overflow-hidden">
            {sectionRightImage && (
              <div className="w-full md:w-1/3 flex justify-around items-center">
                <Image
                  src={sectionRightImage.url}
                  alt={sectionRightImage.alt || 'Right image'}
                  width={sectionRightImage.width || 300}
                  height={sectionRightImage.height || 300}
                  style={{ objectFit: "cover" }}
                />
              </div>
            )}

            <div className="w-full md:w-1/3 py-6 md:py-0 px-3 md:px-0 text-center">
              <div className="page-content">
                <h3 className="font-secondary text-3xl p-2 sm:p-3 md:p-4 tracking-widest mb-7" style={{ color: primaryColor }}>
                  {remainingTitle} <span className="font-special">{lastWord}</span>
                </h3>
                <div className="text-lg font-semibold" dangerouslySetInnerHTML={{ __html: sanitize(sectionContent) }} />
                {buttonText && buttonLink && (
                  <Link href={buttonLink} passHref>
                    <button className="about-button text-white font-bold py-2 px-4 rounded-xl transition duration-300 font-secondary">
                      {buttonText}
                    </button>
                  </Link>
                )}
              </div>
            </div>

            {sectionLeftImage && (
              <div className="w-full md:w-1/3 flex justify-around items-center">
                <Image
                  src={sectionLeftImage.url}
                  alt={sectionLeftImage.alt || 'Left image'}
                  width={sectionLeftImage.width || 300}
                  height={sectionLeftImage.height || 300}
                  style={{ objectFit: "cover" }}
                />
              </div>
            )}
          </div>
        </div>

        <style jsx>{`
          .about-button {
            background-color: ${primaryColor};
          }
          .about-button:hover {
            background-color: ${hoverPrimaryColor};
          }
        `}</style>
      </div>
    </div>
  );
}

export default AboutSection;
